export default __webpack_public_path__ + "static/media/NotoSansSCBold-subset.3747e5f3.woff";